<template>
  <FusionHelpCenter requireResourcesTab input-variant="underlined" />
</template>
